import * as React from "react";
import { Link } from "gatsby";
import * as styles from "./prevNext.module.css";

const PrevNext = ({ pageContext }) => {
  const { previous, next } = pageContext;

  return (
    <footer className={styles.footerContainer}>
      <div className={styles.navRow}>
        {previous ? (
          <Link
            to={`/blog${previous.fields.slug}`}
            className={styles.navButton}
          >
            ←前
          </Link>
        ) : (
          <div className={styles.navButtonGhost}></div>
        )}

        <Link to="/" className={styles.navButton}>
          Home
        </Link>

        {next ? (
          <Link to={`/blog${next.fields.slug}`} className={styles.navButton}>
            次→
          </Link>
        ) : (
          <div className={styles.navButtonGhost}></div>
        )}
      </div>

      <div className={styles.bannerRow}>
        <a
          href="https://sns.mouii.net/@mouii"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.bannerItem}
        >
          <img src="/images/kamunabanner.png" alt="misskey" />
        </a>
        <a
          href="https://cosen.se/benkiopen"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.bannerItem}
        >
          <img src="/images/cosensebanner.png" alt="cosense" />
        </a>
      </div>
    </footer>
  );
};

export default PrevNext;
